<div *ngFor="let variant of variantOptions" class="toolbar-grid-button" (click)="onClick.emit(variant)">
    <div class="grid-preview-img">
        <img [src]="'./assets/img/websites/elements-icon/lpc-structure-icon-' + (variant + 1) + '.svg'" />
    </div>
</div>
